'use server';
import {eq} from 'drizzle-orm';
import {redirect} from 'next/navigation';
import {db, schema} from '@/db';
import {createSession, destroySession} from '@/lib/auth';
import {verifyPassword} from '@/lib/crypto';

export type AuthState = {error?: string};

export async function login(_prev: AuthState, form: FormData): Promise<AuthState> {
  const name = String(form.get('username') || '').trim().toLowerCase(), pass = String(form.get('password') || '');
  const user = (await db.select().from(schema.users).where(eq(schema.users.username, name)).limit(1))[0];
  // Same message for unknown username, wrong password and disabled accounts.
  if (!user || user.disabled || !(await verifyPassword(pass, user.passwordHash))) return {error: 'Хэрэглэгчийн нэр эсвэл нууц үг буруу байна.'};
  await createSession(user.id);
  redirect(user.aiapiKeyEnc ? '/projects' : '/settings');
}

export async function logout() {
  await destroySession();
  redirect('/login');
}
